/** Stage pilot instrumentation stays isolated from production until separately reviewed. */
export function isStageAnalyticsEnabled() {
  return process.env.ENV_TYPE === 'stage';
}
